module.exports = __webpack_public_path__ + "static/media/6. Gunawan.6afd8947.png";